module.exports = __webpack_public_path__ + "vu.3b3fcfb4.svg";